import cx from 'clsx';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useLocalization } from '@fluent/react';

import bookingStepImg1 from '#/assets/img_booking_step_1.png';
import bookingStepImg2 from '#/assets/img_booking_step_2.png';
import bookingStepImg3 from '#/assets/img_booking_step_3.png';
import brandLogo from '#/assets/brand_logo.png';
import easyBookingIcon from '#/assets/icon_easy_booking.png';
import instantDeliveryIcon from '#/assets/icon_instant_delivery.png';
import liveTrackingIcon from '#/assets/icon_live_tracking.png';
import { PublicRoute } from '#/constants/page-route';

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();

  return (
    <div className="relative w-screen min-h-screen bg-white">
      <div className="relative z-10 flex gap-16">
        <div className="flex w-[450px] justify-center items-center">
          <div className="w-[350px]">
            <div className="absolute top-0 left-0 m-12">
              <img
                src={brandLogo}
                className="w-10 hover:cursor-pointer"
                onClick={() => navigate(PublicRoute.Home)}
              />
            </div>
            <main>{children}</main>
            <LoginLayoutFooter />
          </div>
        </div>

        <div className="flex-1 mt-8 overflow-x-auto">
          <Splide options={{ arrows: false, autoWidth: true }}>
            <SplideSlide>
              <BookingStep
                icon={easyBookingIcon}
                image={bookingStepImg1}
                step={1}
                title={l10n.getString('easy-booking')}
                text={l10n.getString('easy-booking-info')}
              />
            </SplideSlide>
            <SplideSlide>
              <BookingStep
                icon={instantDeliveryIcon}
                image={bookingStepImg2}
                step={2}
                title={l10n.getString('instant-delivery')}
                text={l10n.getString('instant-delivery-info')}
              />
            </SplideSlide>
            <SplideSlide>
              <BookingStep
                icon={liveTrackingIcon}
                image={bookingStepImg3}
                step={3}
                title={l10n.getString('live-tracking')}
                text={l10n.getString('live-tracking-info')}
              />
            </SplideSlide>
          </Splide>
        </div>
      </div>

      <div className="absolute top-0 bottom-0 right-0 z-0 w-1/4 bg-white bg-opacity-10"></div>
    </div>
  );
};
export type LoginLayoutProps = {};

const BookingStep: React.FC<BookingStepProps> = ({ icon, image, step, text, title }) => {
  return (
    <div className="">
      <div className="p-8">
        <img className="shadow-2xl rounded-3xl" src={image} />
      </div>

      <div className="relative px-8">
        <div className="relative z-10 space-y-3">
          <h4>{title}</h4>
          <div className="inline-flex items-center justify-center w-8 h-8 text-lg text-white rounded-full bg-primary-400">
            {step}
          </div>
          <img src={icon} className="w-8 h-8" />
          <p className="max-w-sm text-gray-500">{text}</p>
        </div>
        <div
          className={cx(
            'absolute top-[4.2rem] left-0 right-0 h-2 bg-primary-400 z-0',
            // FIXME: more elegant solution
            step === 1 && 'left-12',
          )}
        ></div>
      </div>
    </div>
  );
};
export type BookingStepProps = {
  icon?: string;
  image?: string;
  step: number;
  text: string;
  title: string;
};

/*
 * TODO
 * 1) Change the signup path basd on the current loginUserType.
 */
const LoginLayoutFooter = () => {
  const { l10n } = useLocalization();
  const location = useLocation();
  const signUpLink =
    location.pathname === PublicRoute.LogisticsSignup
      ? PublicRoute.CustomerSignup
      : PublicRoute.LogisticsSignup;

  return (
    <footer className="px-6 py-6">
      <div className="flex justify-center max-w-lg mx-auto space-x-2">
        <div className="text-black">{l10n.getString('no-account-yet-sentence')}</div>
        <Link className="inline-block" to={signUpLink}>
          {l10n.getString('sign-up')}
        </Link>
      </div>
    </footer>
  );
};

export default LoginLayout;
